import { RangeSlider, RangeSliderValue, Text } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { useState } from 'react';

import { RangeSliderFilter } from '../../data-access/types/filters';

import { useColFilter } from '@data-access';

type RangeSliderFilterProps = {
  filter: RangeSliderFilter;
  name: string;
};

export const RangeSliderFilterComponent = ({
  filter,
  name,
}: RangeSliderFilterProps) => {
  const [filterValue, setFilter] = useColFilter('orders', name);
  const [range, setRange] = useState(
    (filterValue as RangeSliderValue) || [null, null],
  );

  const handleRangeChange = useDebouncedCallback((value: RangeSliderValue) => {
    setFilter(value);
  }, 300);

  const handleChange = (value: RangeSliderValue) => {
    setRange(value);
    handleRangeChange(value);
  };

  return (
    <div>
      <Text>{filter.label}</Text>
      <RangeSlider
        label={(value) => value}
        max={filter.range?.[1] ?? 100}
        min={filter.range?.[0] ?? 0}
        onChange={handleChange}
        value={range}
      />
    </div>
  );
};
